import { Guid } from 'guid-typescript';
import { Menu } from './../menu.model';
import { RolepermissionService } from './../../../../pages/RolePermission/rolepermission.service';
import { Component, OnInit, OnChanges, SimpleChanges, Input, HostListener, ElementRef, forwardRef, HostBinding } from '@angular/core';
import { AppSettings } from '../../../../app.settings';
import { Settings } from '../../../../app.settings.model';
import { MenuService } from '../menu.service';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html',
  styleUrls: ['./vertical-menu.component.scss'],
  providers: [MenuService],
  standalone: true,
  imports: [RouterLink, RouterLinkActive, TranslatePipe, NgTemplateOutlet, forwardRef(() => VerticalMenuComponent)]
})
export class VerticalMenuComponent implements OnInit, OnChanges {
  @Input('menuItems') menuItems;
  @Input('menuParentId') menuParentId;
  parentMenu: Array<any> = [];
  public settings: Settings;
  @HostBinding('class.sub-level') get isSubLevel(): boolean { return this.menuParentId != null; }

  constructor(public appSettings: AppSettings,
    public menuService: MenuService,
    public rolepermissionService: RolepermissionService,
    private hostRef: ElementRef<HTMLElement>) {
    this.settings = this.appSettings.settings;
  }

  private setParentMenu(): void {
    const list = this.menuItems || [];
    this.parentMenu = list.filter(item => item.parentId == this.menuParentId);
  }

  ngOnInit() {
    if (this.menuParentId == null) {
      this.menuService.getVerticalMenuItems().then((menuItems) => {
        this.menuItems = menuItems || [];
        this.setParentMenu();
      });
    } else {
      this.setParentMenu();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.menuParentId != null && changes['menuItems']) {
      this.setParentMenu();
    }
  }

  onClick(menuId) {
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);
  }

  trackById(index: number, item: any) {
    return item.id;
  }

  isGroupLabel(menu: any): boolean {
    return !!(menu?.isGroup || menu?.group || menu?.groupLabel);
  }

  isExpanded(menuId: any): boolean {
    const menuItem = document.getElementById('menu-item-' + menuId);
    return !!menuItem?.classList.contains('expanded');
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const links = this.getVisibleMenuLinks();
    if (!links.length) {
      return;
    }
    const activeElement = document.activeElement as HTMLElement | null;
    const currentIndex = activeElement ? links.indexOf(activeElement) : -1;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      const nextIndex = currentIndex >= 0 ? Math.min(currentIndex + 1, links.length - 1) : 0;
      links[nextIndex]?.focus();
      return;
    }

    if (event.key === 'ArrowUp') {
      event.preventDefault();
      const prevIndex = currentIndex >= 0 ? Math.max(currentIndex - 1, 0) : links.length - 1;
      links[prevIndex]?.focus();
      return;
    }

    if (event.key === 'Escape') {
      event.preventDefault();
      this.menuService.closeAllSubMenus();
      activeElement?.blur();
    }
  }

  private getVisibleMenuLinks(): HTMLElement[] {
    const host = this.hostRef.nativeElement;
    return Array.from(host.querySelectorAll<HTMLElement>('.menu-link'))
      .filter(el => el.offsetParent !== null);
  }

}
